<template>
	<div>
		  <a-date-picker show-time>
		      <template slot="renderExtraFooter">
		        extra footer
		      </template>
		    </a-date-picker>
	<a-date-picker
	      :mode="mode1"
	      show-time
	      @openChange="handleOpenChange1"
	      @panelChange="handlePanelChange1"
	    />
  <a-calendar>
    <ul slot="dateCellRender" slot-scope="value" class="events">
      <!-- <li v-for="item in getListData(value)" :key="item.content">
        <a-badge :status="item.type" :text="item.content" />
      </li> -->
	  <a-popconfirm placement="topLeft" ok-text="Yes" cancel-text="No" @confirm="confirm">
	         <template slot="title">
	           <p>{{ TL }}</p>
	           <p>{{ TL }}</p>
	         </template>
	         <a-button>TL</a-button>
	  
	       </a-popconfirm>
    </ul>
    <template slot="monthCellRender" slot-scope="value">
      <!-- <div v-if="getMonthData(value)" class="notes-month">
        <section>{{ getMonthData(value) }}</section>
        <span>Backlog number</span>
      </div> -->
	  <div  class="notes-month">
	    <a-popconfirm placement="topLeft" ok-text="Yes" cancel-text="No" @confirm="confirm">
	           <template slot="title">
	             <p>{{ TL }}</p>
	             <p>{{ TL }}</p>
	           </template>
	           <span><a-button>TL</a-button>
			   </span>
	         </a-popconfirm>
	  </div>
    </template>
  </a-calendar></div>
</template>
<script>
export default {
	 data() {
	    return {
	      mode1: 'time',
	      mode2: ['month', 'month'],
	      value: [],
	    };
	  },
  methods: {
	   handleOpenChange1(open) {
	        if (open) {
	          this.mode1 = 'time';
	        }
	      },
		   handlePanelChange1(value, mode) {
		        this.mode1 = mode;
		      },
    getListData(value) {
      let listData;
      switch (value.date()) {
        case 8:
          listData = [
            { type: 'warning', content: 'This is warning event.' },
            { type: 'success', content: 'This is usual event.' },
          ];
          break;
        case 10:
          listData = [
            { type: 'warning', content: 'This is warning event.' },
            { type: 'success', content: 'This is usual event.' },
            { type: 'error', content: 'This is error event.' },
          ];
          break;
        case 15:
          listData = [
            { type: 'warning', content: 'This is warning event' },
            { type: 'success', content: 'This is very long usual event。。....' },
            { type: 'error', content: 'This is error event 1.' },
            { type: 'error', content: 'This is error event 2.' },
            { type: 'error', content: 'This is error event 3.' },
            { type: 'error', content: 'This is error event 4.' },
          ];
          break;
        default:
      }
      return listData || [];
    },

    getMonthData(value) {
      if (value.month() === 8) {
        return 1394;
      }
    },
  },
};
</script>
<style scoped>
.events {
  list-style: none;
  margin: 0;
  padding: 0;
}
.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}
.notes-month {
  text-align: center;
  font-size: 28px;
}
.notes-month section {
  font-size: 28px;
}
</style>